export default __webpack_public_path__ + "static/media/AG01.4aa68e67.mp3";